import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "inviteCsvUpload" }
const _hoisted_2 = { class: "uploadRow" }
const _hoisted_3 = {
  key: 0,
  class: "fileName"
}
const _hoisted_4 = { class: "mappingSection" }
const _hoisted_5 = {
  key: 0,
  class: "mappingPlaceholder"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InviteCsvMappingForm = _resolveComponent("InviteCsvMappingForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("label", {
      class: "uploadLabel",
      for: "inviteCsvFile"
    }, "Upload a CSV of invites", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        id: "inviteCsvFile",
        ref: "fileInput",
        type: "file",
        accept: ".csv,text/csv",
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args)))
      }, null, 544),
      (_ctx.selectedFileName)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.selectedFileName), 1))
        : _createCommentVNode("", true)
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("p", { class: "uploadHint" }, " If your CSV uses the standard invite column headers it loads as-is. Otherwise, map each invite field to one of your columns below and select Validate Mappings — we support any column layout. Cell values are checked after upload and anything that cannot be read is highlighted in the grid for you to correct. ", -1)),
    _createElementVNode("div", _hoisted_4, [
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "mappingLabel" }, "Mappings", -1)),
      (!_ctx.selectedFile)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Select a CSV to map its columns."))
        : (_openBlock(), _createBlock(_component_InviteCsvMappingForm, {
            key: 1,
            headers: _ctx.headers,
            onValidated: _ctx.onMappingValidated
          }, null, 8, ["headers", "onValidated"]))
    ])
  ]))
}